import { useState } from 'react';

import { Button, Divider, Stack, useTheme } from '@mui/material';

import { ConfirmTypes, useToastStore } from '@/store';

import { useKasePropertyContext } from '../../PropertyContext';

interface PropertyModalFooterProps {
  onClose?: () => void;
  onPrint?: () => void;
  onSave?: () => Promise<boolean>;
}

export const PropertyModalFooter = (props: PropertyModalFooterProps) => {
  const { onClose, onPrint, onSave } = props;
  const theme = useTheme();
  const { updateToast } = useToastStore();
  const { handleCloseCustodyModal, setShouldRefreshProperties } =
    useKasePropertyContext();
  const [loading, setLoading] = useState<boolean>(false);

  const handleSave = async () => {
    try {
      setLoading(true);
      if (onSave) {
        const isSaved = await onSave();
        if (isSaved) {
          setShouldRefreshProperties(true);
          handleCloseCustodyModal();
        }
      }
    } catch (err: any) {
      updateToast({
        open: true,
        message: err.message,
        type: err.message.includes('Dropoff location')
          ? ConfirmTypes.WARNING
          : ConfirmTypes.ERROR,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!onClose) handleCloseCustodyModal();
    else onClose();
  };

  return (
    <Stack
      flexDirection="row"
      sx={{
        width: '100%',
        flexWrap: 'wrap',
        position: 'absolute',
        bottom: 0,
        backgroundColor: theme.palette.background.paper,
        paddingBottom: '15px',
        paddingRight: '30px',
      }}
    >
      <Divider sx={{ width: '100%', my: 2 }} />
      <Button
        variant="contained"
        color="inherit"
        onClick={handleClose}
        sx={{ mr: 1, ml: 'auto' }}
      >
        Cancel
      </Button>

      {!!onPrint && (
        <Button variant="contained" color="error" onClick={onPrint}>
          Print
        </Button>
      )}

      {!!onSave && (
        <Button
          variant="contained"
          color="error"
          onClick={handleSave}
          disabled={loading}
        >
          Save
        </Button>
      )}
    </Stack>
  );
};
